import controller from "emun.cart/cart-item-input.controller";
import templateUrl from "emun.cart/cart-item-input.htm";
import "emun.cart/cart-item-input.scss";

export default {
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
